import { Outlet } from 'react-router';

export function CRMRoot() {
  return (
    <>
      <Outlet />
    </>
  );
}
